<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="$t('customizar-template-notificacao')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="userType !== '5' && !id">
            <el-form-item :label="userType === '1' || userType === '3' ? $t('cliente') : $t('filial')" prop="customer">
              <CustomerList v-model="ruleForm.customer" v-bind:customerType="userType === '2' ? 3 : 1"
                v-bind:current="ruleForm.customer" @selected="customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('notificacao')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <NotificationTemplateList ref="notificationList" :userType="userType" :current="ruleForm.type"
              @selected="changed" />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('mensagem')" prop="template">
          <el-input ref="template" type="textarea" :autosize="{ minRows: 4 }" v-model="ruleForm.template"></el-input>
        </el-form-item>
        <br />
        <el-form-item label="Campos dinamicos" prop="template">
          <el-alert :closable="false">Ao adicionar um campo no texto da mensagem essa informação será substituida pelo
            conteúdo da postagem</el-alert>
          <el-tag><el-link type="primary" @click="add('rastreio')">Rastreio</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('nomeremetente')">Nome Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('cepremetente')">CEP Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('enderecoremetente')">Endereço Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('numeroremetente')">Número Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('complementoremetente')">Complemento Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('bairroremetente')">Bairro Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('cidaderemetente')">Cidade Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('estadoremetente')">Estado Remetente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('cepdestinatario')">CEP Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('enderecodestinatario')">Endereço Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('numerodestinatario')">Número Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('complementodestinatario')">Complemento
              Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('bairrodestinatario')">Bairro Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('cidadedestinatario')">Cidade Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('estadodestinatario')">Estado Destinatário</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('observacao')">Observação</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('servico')">Serviço</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('peso')">Peso</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('valor')">Valor</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('valordeclarado')">Valor Declarado</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('altura')">Altura</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('largura')">Largura</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('comprimento')">Comprimento</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('dataprevisao')">Previsão Entrega</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('nota')">Nota Fiscal</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('pedido')">Pedido</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('nomecliente')">Nome Cliente</el-link></el-tag>
          <el-tag><el-link type="primary" @click="add('cnpj')">CNPJ/CPF Cliente</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('atendimento')">Número
              Atendimento</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('nomeatendimento')">Nome
              Atendimento</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('emailatendimento')">E-mail
              Atendimento</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('valoratendimento')">Valor
              Atendimento</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('autorizacao')">Número
              Autorização</el-link></el-tag>
          <el-tag type="info"><el-link type="info" v-if="userType === '1' || userType === '3'"
              @click="add('etiqueta')">Etiqueta
              Autorização</el-link></el-tag>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{ $t("customizar")
          }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { PackingService } from "@/services/customers/packing.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { UserService } from "@/services/users/user.services";
import { NotificationTemplateService } from "@/services/customers/template.services";
import NotificationTemplateList from "./NotificationTemplateList.vue";

export default {
  name: "NotificationTemplateAdd",
  components: {
    CustomerList,
    NotificationTemplateList
  },
  data() {
    return {
      id: "",
      userType: "2",
      ruleForm: {
        customer: "",
        type: '',
        template: '',
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: 'notification.template' });
    },
    add(tag) {
      this.ruleForm.template = this.ruleForm.template.substring(0, this.$refs.template.$el.children[0].selectionStart) + `{{${tag}}}` + this.ruleForm.template.substring(this.$refs.template.$el.children[0].selectionStart)
      this.$refs.template.$el.children[0].focus();
    },
    changed(template) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      vm.ruleForm.type = template.toLowerCase();
      NotificationTemplateService.configuration(template, vm.ruleForm.customer)
        .then((response) => {
          vm.ruleForm.template = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    customer() {
      const vm = this;
      if (vm.ruleForm.type) {
        vm.changed(vm.ruleForm.type);
      }
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          NotificationTemplateService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("notificacao-customizada-sucesso"),
              });
              this.$refs[formName].resetFields();
              vm.ruleForm.type = '';
            })
            .catch((error) => {
              this.$message({
                dangerouslyUseHTMLString: true,
                duration: 5000,
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          PackingService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("embalagem-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        vm.$refs.template.$el.children[0].focus();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
